import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import SearchIcon from '@atlaskit/icon/core/migration/search';
import TextField from '@atlaskit/textfield';
import VisuallyHidden from '@atlaskit/visually-hidden';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import React, { useLayoutEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl-next';
import { useDebouncedCallback } from 'use-debounce';
import { EMOJI_SEARCH_DEBOUNCE } from '../../util/constants';
import { hidden } from '../common/styles';
import { messages } from '../i18n';
import { input, pickerSearch, searchIcon } from './styles';
export var emojiPickerSearchTestId = 'emoji-picker-search';
export var EmojiPickerListSearch = function EmojiPickerListSearch(props) {
  var style = props.style,
    query = props.query,
    _props$isVisible = props.isVisible,
    isVisible = _props$isVisible === void 0 ? true : _props$isVisible,
    resultsCount = props.resultsCount,
    onChange = props.onChange;
  var textRef = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    dirty = _useState2[0],
    setDirty = _useState2[1];
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;

  // Debounce callback
  var _useDebouncedCallback = useDebouncedCallback(function (value) {
      onChange(value);
      setDirty(true);
    },
    // delay in ms
    EMOJI_SEARCH_DEBOUNCE),
    _useDebouncedCallback2 = _slicedToArray(_useDebouncedCallback, 1),
    debouncedSearch = _useDebouncedCallback2[0];
  var handleOnChange = function handleOnChange(e) {
    debouncedSearch(e.target.value);
  };
  useLayoutEffect(function () {
    requestAnimationFrame(function () {
      if (textRef) {
        var _textRef$current;
        (_textRef$current = textRef.current) === null || _textRef$current === void 0 || _textRef$current.focus();
      }
    });
  }, []);
  return (
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    jsx("div", {
      css: [pickerSearch, !isVisible && hidden],
      style: style
    }, jsx(VisuallyHidden, {
      id: "emoji-search-results-status",
      role: "status"
    }, dirty && query === '' && formatMessage(messages.searchResultsStatusSeeAll), query !== '' && formatMessage(messages.searchResultsStatusSeeAll, {
      // change to messages.searchResultsStatus once translated
      count: resultsCount
    })), jsx(TextField, {
      role: "searchbox",
      "aria-label": formatMessage(messages.searchLabel)
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
      ,
      css: input,
      autoComplete: "off",
      name: "search",
      placeholder: "".concat(formatMessage(messages.searchPlaceholder), "..."),
      defaultValue: query || '',
      onChange: handleOnChange,
      elemBeforeInput:
      // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
      jsx("span", {
        css: searchIcon
      }, jsx(SearchIcon, {
        LEGACY_margin: "0 0 0 2px",
        color: "currentColor",
        spacing: "spacious",
        label: ""
      })),
      testId: emojiPickerSearchTestId,
      ref: textRef,
      isCompact: true
    }))
  );
};